import type { Component } from 'vue'
import FeatureFlagsConfiguration from './components/FeatureFlagsConfiguration.vue'


interface ClippyActionSimple {
  available?: () => boolean
  handler?: (option: string) => void
  message: string
}

interface ClippyActionWithOptions extends ClippyActionSimple {
  handler: (option: string) => void
  options: string[]
}

interface ClippyActionWithComponent extends ClippyActionSimple {
  component: Component
}

export type ClippyAction =
  | ClippyActionSimple
  | ClippyActionWithOptions
  | ClippyActionWithComponent

export const clippyActions: ClippyAction[] = [
  {
    component: FeatureFlagsConfiguration,
    message: 'Configure feature flags',
  },
]

export function isActionSimple (action: ClippyAction): action is ClippyActionSimple {
  return 'message' in action
}

export function isActionWithOptions (action: ClippyAction): action is ClippyActionWithOptions {
  return 'options' in action
}

export function isActionWithComponent (action: ClippyAction): action is ClippyActionWithComponent {
  return 'component' in action
}
